import { render, staticRenderFns } from "./MindAttachmentView.vue?vue&type=template&id=a79d2934&scoped=true"
import script from "./MindAttachmentView.vue?vue&type=script&lang=js"
export * from "./MindAttachmentView.vue?vue&type=script&lang=js"
import style0 from "./MindAttachmentView.vue?vue&type=style&index=0&id=a79d2934&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d2934",
  null
  
)

export default component.exports